import { connect } from 'react-redux';
import getOwnershipSelector from '@/pages/CompanyReport/components/Ownership/redux/selectors';
import { shouldSkipDefer } from '@ducks/ui/selectors/shouldSkipDefer';
import Ownership, {
  OwnershipProps,
} from '@/pages/CompanyReport/components/Ownership';
import { makeInsiderTradingTransactions } from '@/pages/CompanyReport/components/InsiderTradingTransactions/redux/selectors';
import { getViewMode } from '@/redux/location/selectors';
import { areStatesEqualCompanySection } from '@/pages/CompanyReport/redux/selectors';

const mapStateToProps = (
  state,
  ownProps: { companyId?: string; sectionNumber?: number }
): OwnershipProps => {
  const ownership = getOwnershipSelector(state, ownProps);
  const skipDefer = shouldSkipDefer(state);
  const insiderTradingTransactionsSelector = makeInsiderTradingTransactions();
  const insiderTradingTransactions = insiderTradingTransactionsSelector(
    state,
    ownProps
  );
  const viewMode = getViewMode(state);
  return {
    sectionNumber: ownProps.sectionNumber,
    companyId: ownership.companyId,
    uniqueSymbol: ownership.uniqueSymbol,
    insiderTradingTransactions,
    topShareholders: ownership.topShareholders,
    skipDefer,
    totalOwnershipPercent: ownership.totalOwnershipPercent,
    insiderTrading: ownership.insiderTrading,
    viewMode,
    /**
     * Ownership Chart
     */
    ownership: ownership.ownership,
    totalOwnedShares: ownership.totalOwnedShares,
    ownershipDataFormatted: ownership.ownershipDataFormatted,
  };
};

export default connect(mapStateToProps, null, null, {
  areStatesEqual: areStatesEqualCompanySection,
})(Ownership);
